var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgGradientTopWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1927,
    height: 155,
    viewBox: "0 0 1927 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1927,
    y: 154.837,
    width: 1927,
    height: 154.837,
    transform: "rotate(180 1927 154.837)",
    fill: "url(#paint0_linear_4760_37633)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4760_37633",
    x1: 2888.19,
    y1: 154.837,
    x2: 2887.96,
    y2: 276.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99636",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710407,
    stopColor: "#0F8481"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGradientTopWeb);
export default __webpack_public_path__ + "static/media/bg-gradient-top-web.674db6a9efe5f698731ffec70993aba9.svg";
export { ForwardRef as ReactComponent };